import { createSlice } from '@reduxjs/toolkit';
import appSettings from 'app/api/services/appSettings';

const initialState = {
  loading: true,
  fromLogin: false,
  settings: {
    locales: {},
    title: '',
    logo: '',
  },
  drawer: { open: false, title: '', component: null },
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    getSettings: (state, action) => {
      state.loading = false;
      state.settings = action.payload.data;
    },
    showLoading: state => {
      state.loading = true;
    },
    hideLoading: state => {
      state.loading = false;
    },
    setFromLogin: (state, action) => {
      state.fromLogin = action.payload;
    },
    hideGlobalDrawer(state, action) {
      state.drawer = initialState.drawer;
    },
    showGlobalDrawer(state, action) {
      state.drawer = { open: true, ...action.payload };
    },
  },
});

export const fetchAppSettings = () => dispatch => {
  const response = appSettings.getAppSettings();
  dispatch(getSettings(response));
};

export const {
  getSettings,
  showLoading,
  hideLoading,
  setFromLogin,
  hideGlobalDrawer,
  showGlobalDrawer,
} = settingsSlice.actions;

export default settingsSlice;
